var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoClimat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.062,
    height: 36.924,
    viewBox: "0 0 26.062 36.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_30",
    "data-name": "Groupe 30",
    transform: "translate(-896.238 -962.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_29",
    "data-name": "Groupe 29",
    transform: "translate(896.75 962.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_28",
    "data-name": "Groupe 28",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M980.644,1054.861c-1.244,0-2.487,0-3.731,0-.44,0-.832.072-.821.612s.413.594.847.593q3.768-.008,7.536,0c.459,0,.836-.129.829-.623s-.408-.593-.855-.587C983.181,1054.87,981.913,1054.86,980.644,1054.861Z",
    transform: "translate(-960.254 -1036.449)",
    fill: "#68a3c8",
    stroke: "#68a3c8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M980.038,1037.761c1.044,0,2.088,0,3.132,0,.419,0,.834-.062.831-.616s-.429-.6-.843-.6q-3.132-.007-6.264,0c-.417,0-.838.052-.832.611s.427.6.843.605C977.95,1037.766,978.994,1037.761,980.038,1037.761Z",
    transform: "translate(-960.23 -1021.791)",
    fill: "#68a3c8",
    stroke: "#68a3c8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M979.356,1019.424c.846,0,1.693-.009,2.539,0,.416.007.706-.173.717-.576a.6.6,0,0,0-.681-.627c-1.742,0-3.485-.007-5.227,0a.566.566,0,0,0-.634.586c-.007.439.263.609.672.609Z",
    transform: "translate(-960.236 -1007.129)",
    fill: "#68a3c8",
    stroke: "#68a3c8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M978.552,1000.09c-.6,0-1.195,0-1.792,0-.4,0-.692.142-.692.589s.306.607.692.611c1.22.012,2.44.01,3.66,0,.4,0,.7-.207.7-.614s-.282-.6-.7-.589C979.8,1000.1,979.174,1000.09,978.552,1000.09Z",
    transform: "translate(-960.234 -992.614)",
    fill: "#68a3c8",
    stroke: "#68a3c8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M977.657,982.844c.3,0,.6.006.9,0a.57.57,0,0,0,.605-.541.546.546,0,0,0-.517-.623,17.271,17.271,0,0,0-2.089-.006.586.586,0,0,0,.057,1.168C976.959,982.854,977.308,982.844,977.657,982.844Z",
    transform: "translate(-960.206 -977.853)",
    fill: "#68a3c8",
    stroke: "#68a3c8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M910.835,983.679a1.181,1.181,0,0,1-.417-1.035q.012-7.253,0-14.505a5.125,5.125,0,0,0-4.2-5.377,5.047,5.047,0,0,0-6.05,4.644c-.085,4.983-.045,9.969-.026,14.953a1.906,1.906,0,0,1-.662,1.528,8.484,8.484,0,0,0,4.338,14.546,6.513,6.513,0,0,0,.736.12c.248.021.5,0,.747,0a8.48,8.48,0,0,0,5.53-14.879Zm1.318,8.764a7.283,7.283,0,1,1-11.343-8.122,1.281,1.281,0,0,0,.539-1.137c-.014-2.591-.007-5.182-.007-7.773h.014c0-2.641-.045-5.283.014-7.922a3.89,3.89,0,0,1,4.656-3.542,3.948,3.948,0,0,1,3.189,4.248q.012,7.437-.006,14.873a1.514,1.514,0,0,0,.611,1.329A7.174,7.174,0,0,1,912.152,992.443Z",
    transform: "translate(-896.75 -962.654)",
    fill: "#68a3c8",
    stroke: "#68a3c8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M926.257,1053.458a.831.831,0,0,1-.666-.988c.039-1.868.01-3.738.018-5.606,0-.431-.037-.854-.567-.871-.576-.019-.644.419-.639.883.009,1,0,1.994,0,2.99,0,.474-.015.947,0,1.42.043,1.093.15,2.006-1.3,2.557-1.516.576-2.018,2.541-1.474,4.106a3.585,3.585,0,0,0,6.946-.742A3.5,3.5,0,0,0,926.257,1053.458Zm-1.262,5.685a2.4,2.4,0,0,1-2.37-2.369,2.451,2.451,0,0,1,2.446-2.389,2.421,2.421,0,0,1,2.323,2.427A2.381,2.381,0,0,1,924.995,1059.143Z",
    transform: "translate(-916.495 -1029.356)",
    fill: "#68a3c8",
    stroke: "#68a3c8",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoClimat);
export default __webpack_public_path__ + "static/media/picto-climat.09e5914831a380590e3e34b6f4ecf3b6.svg";
export { ForwardRef as ReactComponent };